var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTransportationTerms(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96.875,
    height: 51.198,
    viewBox: "0 0 96.875 51.198",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TRansportvillkor",
    transform: "translate(0.95 0.954)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustrationer",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26723",
    "data-name": "Group 26723",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_3790",
    "data-name": "Line 3790",
    y1: 6.103,
    transform: "translate(21.792 35.743)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37364",
    "data-name": "Path 37364",
    d: "M359.411,183.3H326.633v1.171a1.431,1.431,0,0,1-1.348,1.494H323.6",
    transform: "translate(-304.863 -141.454)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3791",
    "data-name": "Line 3791",
    x1: 4.943,
    transform: "translate(63.714 41.846)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1234",
    "data-name": "Ellipse 1234",
    cx: 4.898,
    cy: 5.43,
    rx: 4.898,
    ry: 5.43,
    transform: "translate(8.964 38.433)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1235",
    "data-name": "Ellipse 1235",
    cx: 4.898,
    cy: 5.43,
    rx: 4.898,
    ry: 5.43,
    transform: "translate(54.278 38.433)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1236",
    "data-name": "Ellipse 1236",
    cx: 4.898,
    cy: 5.43,
    rx: 4.898,
    ry: 5.43,
    transform: "translate(68.297 38.433)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1237",
    "data-name": "Ellipse 1237",
    cx: 2.629,
    cy: 2.914,
    rx: 2.629,
    ry: 2.914,
    transform: "translate(11.233 40.949)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1238",
    "data-name": "Ellipse 1238",
    cx: 2.629,
    cy: 2.914,
    rx: 2.629,
    ry: 2.914,
    transform: "translate(56.547 40.949)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1239",
    "data-name": "Ellipse 1239",
    cx: 2.629,
    cy: 2.914,
    rx: 2.629,
    ry: 2.914,
    transform: "translate(70.566 40.949)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37365",
    "data-name": "Path 37365",
    d: "M512.55,110.1h7.5a1.593,1.593,0,0,1,1.505,1.669v3.363a1.594,1.594,0,0,1-1.505,1.669H509",
    transform: "translate(-508.663 -86.487)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3792",
    "data-name": "Line 3792",
    x1: 4.493,
    transform: "translate(63.938 45.109)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37366",
    "data-name": "Path 37366",
    d: "M278.547,105.805h3.662a.841.841,0,0,0,.427-1.494l-3.729-2.939h-56.3v-19.6A1.593,1.593,0,0,0,221.1,80.1h-11.57a1.505,1.505,0,0,0-1.3.822l-7.009,13.2a3.372,3.372,0,0,0-.4,1.619V107.1a1.593,1.593,0,0,0,1.505,1.669h7.549",
    transform: "translate(-200.814 -63.96)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37367",
    "data-name": "Path 37367",
    d: "M183.875,15.525l38.642,29.242A4.023,4.023,0,0,1,223.348,50l-2.381,3.761L179.539,22.375a1.294,1.294,0,0,1-.27-1.694l3.055-4.832A1.037,1.037,0,0,1,183.875,15.525Z",
    transform: "translate(-136.944 -15.302)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3793",
    "data-name": "Line 3793",
    y1: 14.248,
    x2: 7.301,
    transform: "translate(57.401 23.189)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3794",
    "data-name": "Line 3794",
    x1: 7.818,
    y2: 15.269,
    transform: "translate(55.311 22.168)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37368",
    "data-name": "Path 37368",
    d: "M173.1,60.068l5.324-1.768.764,2.391,2.629-1.2v3.188h2.718l1.281,3.288,3.527-.772,1.348,2.416,2.9.623,1.236,3.985,2.831.872.831,2.964-1.64,2.516",
    transform: "translate(-110.128 -47.59)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37369",
    "data-name": "Path 37369",
    d: "M147.942,144.5h2.786l1.325,1.893,3.3,1.669-2.561,3.039h-3.5l-.831-2.516-2.359.4",
    transform: "translate(-60.931 -112.319)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.9
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTransportationTerms);
export default __webpack_public_path__ + "static/media/Icon_transportationTerms.b82d7f8a4e039aa5989be464f0288c6e.svg";
export { ForwardRef as ReactComponent };